import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { SegmentoNivelEndeudamiento } from '../_models/segmento-nivel-endeudamiento';

@Injectable({
  providedIn: 'root'
})
export class SegmentoNivelEndeudamientoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/segmentosNivelesEndeudamientos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as SegmentoNivelEndeudamiento[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as SegmentoNivelEndeudamiento[] ) );
  }

  obtenerPorSegmento( idSegmento: string ) {
    return this.httClient.get( this.rutServicio + '/segmento/' + idSegmento ).pipe( map( res => res as SegmentoNivelEndeudamiento[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as SegmentoNivelEndeudamiento ) );
  }

  agregar( regCrear: SegmentoNivelEndeudamiento ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as SegmentoNivelEndeudamiento ) );
  }

  actualizar( regActualizar: SegmentoNivelEndeudamiento ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as SegmentoNivelEndeudamiento ) );
  }

  politicaCredito( idPoliticaC: string ) {
    return this.httClient.get( this.rutServicio + '/politicaCredito/disableb/' + idPoliticaC ).pipe( map( res => res ) );
  }
}
